/* eslint-disable import/prefer-default-export, quote-props */

import { SalesRecordingType } from '@marageti/z4-sdk/lib/travel/SalesRecording';

export const monthMap:{ [key:string]: string[] } = {
  '01': ['January', 'Jan'],
  '02': ['February', 'Feb'],
  '03': ['March', 'Mar'],
  '04': ['April', 'Apr'],
  '05': ['May', 'May'],
  '06': ['June', 'Jun'],
  '07': ['July', 'Jul'],
  '08': ['August', 'Aug'],
  '09': ['September', 'Sep'],
  '10': ['October', 'Oct'],
  '11': ['November', 'Nov'],
  '12': ['December', 'Dec'],
};

/**
 * Format the invoice date to MMMM YYYY'
 * @param invoiceDate the inovice date in the format of 'YYYY-MM'
 */
export const formatInvoiceMonth = (invoiceDate:string) => {
  if (!invoiceDate) return '-';
  const [year, month] = invoiceDate.split('-');
  if (!monthMap[month]) return '-';
  return `${monthMap[month][0]} ${year}`;
};

/**
 * Format the created date to MMM d, yyyy'
 * @param createdAt the inovice date string in the format of 'YYYY-MM'
 */
export const formatDateSold = (createdAt: string) => {
  if (!createdAt) return '-';
  const [date] = createdAt.split('T');
  const [year, month, day] = date.split('-');
  const dayNoLeadingZero = day.startsWith('0') ? day.slice(1) : day;
  if (!monthMap[month]) return '-';
  return `${monthMap[month][1]} ${dayNoLeadingZero}, ${year}`;
};

export const salesRecordingTypeLabel = {
  [SalesRecordingType.Adjustment]: 'Sales Adjustment',
  [SalesRecordingType.General]: 'Standard Sale',
  [SalesRecordingType.PartnerRepeat]: 'Repeat Sale',
  [SalesRecordingType.TravelerReferral]: 'Referral Sale',
  [SalesRecordingType.CommissionAfterTravel]: 'Commission After Travel',
  [SalesRecordingType.PlanningFee]: 'Planning Fee',
  [SalesRecordingType.RefundCredit]: 'Refund Credit',
};
